module.exports = __webpack_public_path__ + "img/wxchar.b012e104.png";